import script from "./DocEditorLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DocEditorLayout.vue?vue&type=script&setup=true&lang=js"

import "./DocEditorLayout.vue?vue&type=style&index=0&id=01ab59fa&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ab59fa"]])

export default __exports__